import React from "react";
import axios from 'axios';
import { MDBInput } from "mdbreact";
import { Button } from 'reactstrap'

export default class MapForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            ...props,
            inputValues: ['ClientHydrantID'
                , 'HydrantType', 'HydrantColor'
                , 'HydrantManufacturer', 'NearestStreetAddress'
                , 'SubdivisionName', 'InspectionFrequency'
                , 'LastInspectionDate', 'LastInspectionResult'
                , 'NextInspectionDueDate', 'YearInstalled'
                , 'Latitude', 'Longitude', 'IsolationValve'
                , 'SnowPlugFlag'],
            hydrant: props.data.ClientID ? { ...props.data } : {
                ClientID: 1,
                GlobalID: '0E984725-C51C-4BF4-9960-E1C80D27ABA0',
                Created_User: 'Brad Ciechanowski',
                Created_Date: '2022-07-10',
                Last_Editor: 'Brad Ciechanowski',
                Last_Edited_Date: '2022-07-10'
            },
            dropDownArray: ['HydrantType', 'HydrantColor', 'HydrantManufacturer'],
            dropDownObjects: [{ HydrantType: ['commercial', 'residential'] }, { HydrantColor: ['red', 'yellow'] }, { HydrantManufacturer: ['Manu1', 'Manu2'] }],
            checkboxArray: ['IsolationValve', 'SnowPlugFlag']
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            hydrant: {
                ...this.state.hydrant,
                ...nextProps.data,
                Latitude: nextProps.addedLatLng.lat ? nextProps.addedLatLng.lat : null,
                Longitude: nextProps.addedLatLng.lng ? nextProps.addedLatLng.lng : null,
            },
            isEdit: nextProps.data && nextProps.data.HydrantID ? true : false
        })
    }

    onSubmit = async (e) => {
        e.preventDefault()
        if (this.state.isEdit) {
            await axios.post('/api/hydrantUPD', this.state.hydrant)
                .then(response => {
                    window.location.reload()
                })
                .catch(error => console.log('error', error))
        } else {
            await axios.post('/api/hydrantIns', this.state.hydrant)
                .then(response => {
                    window.location.reload()
                })
                .catch(error => console.log('error', error))
        }
    }
    changeValue = (e) => {
        this.setState({
            hydrant: {
                ...this.state.hydrant,
                [e.target.name]: e.target.value
            }
        })
    }
    render() {
        return (
            <div className="map-form">
                <form className="mapInput">
                    <h5 style={{ textAlign: 'center' }}>Hydrant Information</h5>
                    <p style={{ textAlign: 'center', fontSize: "12px" }}>Add Hydrant to Map by clicking its respective Location.</p>
                    {this.state.hydrant && this.state.inputValues.filter(y => !y.includes('itude') && !y.includes('LastInspection') && !y.includes('NextInspection')).map((x, index) =>
                        <div>
                            {this.state.dropDownArray.includes(x) ?
                                <select className={this.state.dropDownArray.includes(this.state.inputValues[index + 1]) ? "browser-default custom-select dropdownSelect" : "browser-default custom-select dropdownSelect2"} key={index}>
                                    <option hidden>{x.replace(/([A-Z])/g, ' $1').trim()}</option>
                                    {this.state.dropDownObjects[this.state.dropDownArray.findIndex(tt => tt === x)][x].map(obj => <option value={obj}>{obj}</option>)}

                                </select>
                                : this.state.checkboxArray.includes(x) ?
                                    <div className="custom-control custom-checkbox checkboxMap">
                                        <input type="checkbox" className="custom-control-input" id={x} checked={this.state.hydrant[x]}/>
                                            <label className="custom-control-label" for={x}>{x}</label>
                                    </div>
                                    : <MDBInput
                                        key={index}
                                        label={x.includes('ID') ?
                                            'Client Hydrant Id'
                                            : x.includes('Frequency') ?
                                                'Inspection Frequency (months)'
                                                : x.replace(/([A-Z])/g, ' $1').trim()}
                                        outline
                                        size="sm"
                                        className="mdFormOutline"
                                        labelClass="muiLabel"
                                        name={x}
                                        type={x.includes('Frequency') ? 'number' : 'text'}
                                        value={this.state.hydrant[x] ? this.state.hydrant[x] : ''}
                                        onChange={(e) => this.changeValue(e)}
                                    />}
                        </div>
                    )}
                    {this.state.hydrant && this.state.inputValues.filter(y => y.includes('itude') || y.includes('LastInspection') || y.includes('NextInspection')).map((x, index) =>
                        <p style={{ fontSize: '13px', paddingLeft: '3px' }}><b>{x.replace(/([A-Z])/g, ' $1').trim()}:</b> <span>{this.state.hydrant[x]}</span></p>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingTop: '15px' }}>
                        <Button color="primary" size='sm' onClick={(e) => this.onSubmit(e)}>Submit</Button>
                        <Button color="primary" outline size='sm' onClick={() => this.state.cancel()} >Cancel</Button>
                    </div>
                </form>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MapForm.js